import { isNull } from 'lodash';

type StatCardProps = {
    metricName?: string;
    absoluteValue?: number;
    changedVal?: number;
    percentChange?: number;
    unit?: string;
};

const StatCard = ({ metricName = '', absoluteValue = 0, changedVal, percentChange, unit = '' }: StatCardProps) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        notation: 'compact', // gives you K / M / B
        compactDisplay: 'long', // "short" = 20K, "long" = 20 thousand
        maximumFractionDigits: 2, // control decimals
    });
    const isTrendPositive = changedVal && changedVal > 0 ? true : false;

    // Format percentage change safely
    const formatPercentChange = () => {
        if (percentChange === undefined || percentChange === null) {
            return 'N/A';
        }
        if (!isFinite(percentChange)) {
            return 'N/A';
        }
        return `${percentChange.toFixed(0)}%`;
    };

    return (
        <div className="flex flex-col border border-[#0000000F] rounded-lg px-4 py-2 w-64">
            <div className="flex flex-row items-center">
                <p className="mr-2 text-[#000000] opacity-40 font-normal text-sm">{metricName}</p>
                {changedVal && (
                    <p className={`text-xs ${isTrendPositive ? 'text-[#42A531]' : 'text-[#CA3D3D]'}`}>
                        {formatter.format(changedVal).replace(/([KMB])$/, ' $1')} ({formatPercentChange()})
                    </p>
                )}
            </div>
            <div className="flex">
                <p className="text-2xl font-semibold">
                    {isNull(absoluteValue)
                        ? 'N/A'
                        : unit === '%'
                        ? `${absoluteValue >= 0 ? '+' : '-'}${absoluteValue.toFixed(2)} %`
                        : formatter.format(absoluteValue).replace(/([KMB])$/, ' $1')}
                </p>
            </div>
        </div>
    );
};

export default StatCard;
